import { gql } from "@apollo/client";

export interface ActiveAnnouncementListItem {
    product: string;
    activeAnnouncements: number;
}

export const GET_FEATURE_ANNOUNCEMENTS = gql`
    query GetFeatureAnnouncements($threeMonthsAgo: timestamp!) {
        announcements: uccm_announcements(order_by: { startdate: desc }) {
            id
            name
            startdate
            enddate
            state
            targetproduct
        }

        active_announcements_inspectionapp: uccm_announcements_aggregate(
            where: {
                state: { _eq: 20 }
                startdate: { _lt: "now()" }
                enddate: { _gt: "now()" }
                targetproduct: { _eq: 1 }
            }
        ) {
            aggregate {
                count(columns: targetproduct)
            }
        }

        active_announcements_portal: uccm_announcements_aggregate(
            where: {
                state: { _eq: 20 }
                startdate: { _lt: "now()" }
                enddate: { _gt: "now()" }
                targetproduct: { _eq: 2 }
            }
        ) {
            aggregate {
                count(columns: targetproduct)
            }
        }

        modal_views_last_3_months: uccm_announcementaudits_aggregate(
            where: { event: { _eq: 30 }, timestamp: { _gte: $threeMonthsAgo } }
        ) {
            aggregate {
                count(columns: id)
            }
        }

        modal_announcements_last_3_months: uccm_announcementaudits_aggregate(
            where: { event: { _eq: 10 }, timestamp: { _gte: $threeMonthsAgo } }
        ) {
            aggregate {
                count(columns: id)
            }
        }
    }
`;
